__turbopack_context__.v({
  "close": "videomodal-module__u9wBra__close",
  "content": "videomodal-module__u9wBra__content",
  "modal": "videomodal-module__u9wBra__modal",
  "overlay": "videomodal-module__u9wBra__overlay",
  "player": "videomodal-module__u9wBra__player",
  "pop": "videomodal-module__u9wBra__pop",
  "videoBtn": "videomodal-module__u9wBra__videoBtn",
  "videoBtnWrap": "videomodal-module__u9wBra__videoBtnWrap",
});
